@if (modals.length > 0 && topModal) {
  <div
    class="pkg-modal-background pkg-modal-backdrop-click"
    [style.z-index]="200000 + topModal.id"
    (click)="topModal.hideCloseBt !== true && removeModal(topModal.id)">
  </div>

  @for (m of modals; track m.id) {
    <div
      class="pkg-modal"
      [ngClass]="m.animationClass || ('modal-in-' + (m.presentation || 'from-bottom'))"
      [style.z-index]="200000 + m.id"
      [style.--content-max-width]="m.contentMaxWidth || '1300px'"
      role="dialog"
      [attr.aria-label]="m.title || 'Modal'"
      (click)="$event.stopPropagation()">
      @if (m.id === topModal.id && !m.hideCloseBt) {
        <pkg-action-button
          iconName="cross"
          iconColor="#fff"
          position="fixed-top-left"
          color="var(--main-color)"
          (callBack)="removeModal(m.id)">
        </pkg-action-button>
      }
      @if ((m.title ?? '').trim().length > 0) {
        <div class="pkg-modal-title">
          <h3>{{ m.title }}</h3>
        </div>
      }
      <div
        class="pkg-modal-content"
        [class.pkg-modal-has-sticky-footer]="m.hasStickyFooter === false"
        [class.pkg-modal-is-centered]="m.isCentered === true"
        [class.pkg-modal-max-width]="!!m.contentMaxWidth"
        [style.--content-max-width]="m.contentMaxWidth">
        <pkg-modal-host [modal]="m" (closeRequested)="removeModal(m.id, $event)"></pkg-modal-host>
      </div>
    </div>
  }
}
